import DataSourceList from './src/index.vue'

/* istanbul ignore next */
DataSourceList.install = function (Vue) {
  Vue.component(DataSourceList.name, DataSourceList)
}

export default DataSourceList
